module.exports = __webpack_public_path__ + "static/assets/c1a003c23ee298763e3dabd1e281a85d.png";